export default "__VITE_ASSET__BR1S8$oy__"